import displayFieldLabel from 'src/utils/displayFieldLabel';

export default {
  mixins: [displayFieldLabel],
  methods: {
    getLowerConfidence(field: any) {
      if (field.confidence && field.score) {
        let converted_confidence =
          field.confidence < 1
            ? (field.confidence.toFixed(2) * 100).toFixed(0)
            : (field.confidence.toFixed(2) as number);
        let converted_score =
          field.score <= 1
            ? (field.score.toFixed(2) * 100).toFixed(0)
            : (field.score.toFixed(2) as number);
        converted_confidence = Number(converted_confidence);
        converted_score = Math.floor(Number(converted_score));
        return converted_confidence < converted_score
          ? converted_confidence
          : converted_score;
      } else if (field.confidence) {
        return (
          field.confidence < 1
            ? (field.confidence.toFixed(2) * 100).toFixed(0)
            : field.confidence.toFixed(2)
        ) as number;
      }
      return null;
    },
    getInputFieldWidth(elementObj: any) {
      if (!elementObj.displayLabelOnLeft) {
        return 100;
      }

      return 100 - +elementObj.labelWidth;
    },
  },
};
